export default {

    loading: true,
    project_lead: {
        companies: null,
        notes: '',
    }
}
